import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AccountService } from 'app/account/account.service';
import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SupportFinancialDashboardService extends BaseService {
    private _apiSupportUrl: string = `${environment.apiSupport}`;
    private _domain: string = '/financial-dashboard';

    constructor(private accountService: AccountService, private config: SettingsService) {
        super();
    }

    public getTransactedCashbackValueData(month: number, year: number) {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/transacted-cashback-value?year=${year}&month=${month}`});
    }

    public getTransactedCommerceValueData(month: number, year: number) {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/transacted-commerce-value?year=${year}&month=${month}`});
    }

    public getTransactedValueData(month: number, year: number): Observable<any> {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/transacted-value?year=${year}&month=${month}`});
    }

    public getTransactedValueByDayData(month: number, year: number) {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/transacted-value-by-day?year=${year}&month=${month}`});
    }
}
